import { Badge, type BadgeColor, CircularProgress } from '@civilgrid/ui/components';
import type React from 'react';
import type { useValidateGeometry } from '~/hooks/useValidateGeometry';

export type InvalidGeometryBadgeProps = {
  query: ReturnType<typeof useValidateGeometry>;
};

export default function InvalidGeometryBadge({ query }: InvalidGeometryBadgeProps) {
  const { data, isError, isFetching } = query;

  if (isFetching) {
    return (
      <Wrapper color="yellow">
        <CircularProgress indeterminate tone="neutral" size={12} ariaLabel="Validating geometry" />
        <span aria-hidden="true">Validating geometry</span>
      </Wrapper>
    );
  }

  if (isError) {
    return <Wrapper color="red">Error validating geometry</Wrapper>;
  }

  if (data) {
    if (!data.isValid) {
      let text = 'Invalid';
      if (data.isValidReason.toLowerCase().includes('self-intersection')) {
        text = 'Self-intersection - project segments cannot intersect';
      }
      return <Wrapper color="red">⚠️ {text}</Wrapper>;
    }
  }

  return null;
}

function Wrapper({ color, children }: { color: BadgeColor; children: React.ReactNode }) {
  return (
    <Badge color={color} className="gap-2">
      {children}
    </Badge>
  );
}
